// @flow

import qs from 'qs';
import Api from './ApiBase';

export const getParams = (params: any) => qs.stringify({
  include: 'job_alerts.categories,job_alerts.industries,job_alerts.regions,job_alerts.work_types,job_alerts.entry_levels,job_alerts.job_languages,job_alerts.number_employees_groups,job_alerts.place,likes',
  ...params
});

class UserApi extends Api {
  fetch = async (params: {} = {}) => {
    const json = await this.request(`user?${getParams(params)}`);
    const data = await this.deserialize(json);

    return { data, meta: json.meta };
  }
}

export default new UserApi();
